<template>
    <v-col cols="12" md="6">
        <div class="text-right">
            <v-btn text small color="error" @click="handleDeleteButtonClick">Delete client</v-btn>
        </div>
        <client-form :client="client"
                     ref="client-update-form"
                     :errorMessagesByFields="validationErrors('updateClient')"
                     @validation-changed="handleFormValidationChanged"
                     @fieldChanged="handleFieldChanged"/>
        <div class="text-right">
            <v-spacer></v-spacer>
            <v-btn color="success" :disabled="!saveButtonActive" @click="handleSaveButtonClick"
                   :loading="progress('updateClient')">
                Save
            </v-btn>
            <v-btn class="ml-2" @click="handleCancelButtonClick">
                Cancel
            </v-btn>
        </div>
        <confirm ref="delete-confirm"></confirm>
    </v-col>
</template>

<script>
    import _ from 'lodash'
    import Confirm from '../../Common/Confirm'
    import ClientForm from '../Components/ClientForm';
    import {mapGetters, mapActions, mapState} from 'vuex'

    export default {
        name: "UpdateClient",
        props: {
            client: Object
        },
        components: {
            ClientForm,
            Confirm
        },
        data () {
            return {
                formValid: false
            }
        },
        computed: {
            ...mapState('clients', {
            }),
            ...mapGetters('clients', {
                progress: 'progress',
                validationErrors: 'validationErrors',
                validationErrorsByField: 'validationErrorsByField'
            }),
            saveButtonActive () {
                return this.formValid && !this.progress('updateClient')
            }
        },
        mounted () {
            this.formValid = this.$refs['client-update-form'].isValid()
        },
        methods: {
            ...mapActions({
                update: 'clients/updateClient',
                delete: 'clients/deleteClient',
                resetValidationErrorsByField: 'clients/resetValidationErrorsByField'
            }),
            async handleSaveButtonClick () {
                if (!this.$refs['client-update-form'].isValid()) {
                    return
                }

                const formData = this.$refs['client-update-form'].getFormData()
                const updateResult = await this.update(formData)

                if (!updateResult) {
                    return
                }
            },
            handleFormValidationChanged (value) {
                this.formValid = value
            },
            handleCancelButtonClick () {
                this.$refs['client-update-form'].reset()
                this.$router.push('/clients')
            },
            handleFieldChanged ({fieldName}) {
                if (_.get(this.validationErrorsByField, ['updateClient', fieldName], false)) {
                    return
                }

                this.resetValidationErrorsByField({context: 'updateClient', fieldName: fieldName})
            },
            handleDeleteButtonClick () {
                this.$refs['delete-confirm'].open('Delete client', `Do you want to delete client: "${this.client.title}"?`, {width: 600}).then(async (confirm) => {
                    if (!confirm) {
                        return
                    }

                    try {
                        let result = await this.delete(this.client)

                        if (result) {
                            this.$router.push('/clients')
                        }
                    } catch (e) {
                        console.log(e)
                    }
                })
            }
        }
    }
</script>

<style scoped>

</style>